import { req } from '../../@api/request';

const baseURL = `${process.env.REACT_APP_HOST_API || 'http://localhost:3333'}`;

export default class LoginSerivce {
  static login = async (data: any) => {
    const result = await req.post('/users/sign/in', data);
    return result.data;
  };

  static socialLogin = (type: string, url: string) => {
    url = baseURL + `users/sign/in/${type}?client=${url}`;
    window.location.href = url; // 현재창에서 로그인
  };
}
